<section class="streams-list" 
  [style.--columns]="columns"
  [ngClass]="{
  'grid--display' : display && display === 'grid' || 'windows',
  'theme--grid': display && display === 'grid',
  'theme--windows': display && display === 'windows',
  'show--placeholders': showPlaceholders 
  }">
  <ng-container *ngIf="(showPlaceholders && !loadingData) || !showPlaceholders">
    <div class="streams-list__stream-wrapper" *ngFor="let stream of streamsList">
      <div class="streams-list__stream-wrapper__main-info">
        <img-lazy-loading
          class="streams-list__stream-wrapper__main-info__image"
          *ngIf="stream.iconImageThbs && stream.iconImageUrl"
          [url]="['/notes', stream.id, stream.indexedName || stream.name || stream.id]"
          [mainThumb]="stream.iconImageUrl"
          [thumbs]="stream.iconImageThbs"
          [url]="stream.shortURLPath ? ['/s', stream.shortURLPath] : ['/streams', stream.id, 'view', stream.name]"
          [title]="'Read more about ' + stream.name"></img-lazy-loading>
        <div class="streams-list__stream-wrapper__main-info__details">
          <a
            [routerLink]="stream.shortURLPath ? ['/s', stream.shortURLPath] : ['/streams', stream.id, 'view', stream.name]"
            class="streams-list__stream-wrapper__main-info__details__title">{{stream.name}}</a>
          <p class="streams-list__stream-wrapper__main-info__details__description" *ngIf="stream.description">{{stream.description}}</p>
        </div>
      </div>
      <ul class="streams-list__stream-wrapper__notes" *ngIf="extendedList">
        <li
          class="streams-list__stream-wrapper__notes__note"
          [ngClass]="{'include--images' : notesImages}"
          *ngFor="let note of stream.notes | slice:0:2">
          <img-lazy-loading
            class="note-img"
            *ngIf="note.thumbnailMeta && note.thumbnails && note.thumbnailImage"
            [url]="note.shortURLPath ? ['/n', note.shortURLPath] : ['/notes', note.id, note.indexedName || note.name || note.id]"
            [mainThumb]="note.thumbnailImage"
            [thumbs]="note.thumbnails"
            [title]="'Read more about ' + note.name"></img-lazy-loading>
          <div class="streams-list__stream-wrapper__notes__note__description">
            <a
            [routerLink]="note.shortURLPath ? ['/n', note.shortURLPath] : ['/notes', note.id, note.indexedName || note.name || note.id]"
            title="Read about {{note.name}}"
            class="streams-list__stream-wrapper__notes__note__description__title">{{note.name}}</a>
            <div class="streams-list__stream-wrapper__notes__note__description__tags" *ngIf="note.price === 0">
              <span class="streams-list__stream-wrapper__notes__note__description__tags__tag tag--free-note" *ngIf="note.price === 0">free note</span>
            </div>
            <span class="streams-list__stream-wrapper__notes__note__description__date">
              {{note.published || note.created | date: 'MMM dd, yyyy' }}
            </span>
          </div>
        </li>
      </ul>
    </div>
  </ng-container>
  <ng-container *ngIf="showPlaceholders && loadingData">
    <section
      *ngFor="let num of [].constructor(limit/2); let i = index"
      class="streams-list__stream-wrapper">
      <section class="streams-list__stream-wrapper__placeholder">
        <div class="streams-list__stream-wrapper__placeholder__info">
          <span class="streams-list__stream-wrapper__placeholder__info__image"></span>
          <span class="streams-list__stream-wrapper__placeholder__info__title"></span>
        </div>
        <div class="streams-list__stream-wrapper__placeholder__notes">
          <span class="streams-list__stream-wrapper__placeholder__notes__note"></span>
          <span class="streams-list__stream-wrapper__placeholder__notes__note"></span>
        </div>
      </section>
    </section>
  </ng-container>
</section>